const TOGGLE = '[data-bs-toggle="collapse"]';

const getSelector = (trigger) => {
    const sel = trigger.getAttribute("data-bs-target") || trigger.getAttribute("href");
    return sel && sel !== "#" ? sel : null;
};

const fire = (el, name, cancelable = false) =>
    el.dispatchEvent(new CustomEvent(name, { bubbles: true, cancelable }));

function setState(target, show) {
    if (target.classList.contains("show") === show) return;

    // Cancelable "before" event, like Bootstrap
    if (!fire(target, show ? "show.bs.collapse" : "hide.bs.collapse", true)) return;

    target.classList.toggle("show", show);

    // Sync every trigger that points at this target
    document.querySelectorAll(TOGGLE).forEach((t) => {
        const sel = getSelector(t);
        if (sel && target.matches(sel)) {
            t.setAttribute("aria-expanded", String(show));
            t.classList.toggle("collapsed", !show);
        }
    });

    fire(target, show ? "shown.bs.collapse" : "hidden.bs.collapse");
}

document.addEventListener("click", (e) => {
    const trigger = e.target.closest(TOGGLE);
    if (!trigger) return;
    e.preventDefault();

    const selector = getSelector(trigger);
    if (!selector) return;

    document.querySelectorAll(selector).forEach((target) => {
        const show = !target.classList.contains("show");

        // Accordion behaviour: close the other open items sharing this parent
        const parentSel = target.dataset.bsParent;
        if (show && parentSel) {
            document.querySelectorAll(`${parentSel} .collapse.show`).forEach((open) => {
                if (open !== target && open.dataset.bsParent === parentSel) {
                    setState(open, false);
                }
            });
        }

        setState(target, show);
    });
});